/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewMailbox
 */
export interface NewMailbox {
    /**
     * 
     * @type {number}
     * @memberof NewMailbox
     */
    mailboxNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof NewMailbox
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewMailbox
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewMailbox interface.
 */
export function instanceOfNewMailbox(value: object): value is NewMailbox {
    return true;
}

export function NewMailboxFromJSON(json: any): NewMailbox {
    return NewMailboxFromJSONTyped(json, false);
}

export function NewMailboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewMailbox {
    if (json == null) {
        return json;
    }
    return {
        
        'mailboxNumber': json['mailboxNumber'] == null ? undefined : json['mailboxNumber'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewMailboxToJSON(json: any): NewMailbox {
    return NewMailboxToJSONTyped(json, false);
}

export function NewMailboxToJSONTyped(value?: NewMailbox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mailboxNumber': value['mailboxNumber'],
        'userId': value['userId'],
        'courierId': value['courierId'],
    };
}

